import useScrollAnimation from "@/hooks/useScrollAnimation";

export default function CTABanner() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const { ref, isVisible } = useScrollAnimation(0.3);

  return (
    <section className="w-full py-14 md:py-18 bg-primary-500">
      <div
        ref={ref}
        className={`w-full px-4 md:px-6 lg:px-10 transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
        }`}
      >
        <div className="max-w-5xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-6 lg:gap-10">
          <div className="text-center lg:text-left">
            <p className="text-xs md:text-sm font-semibold text-background-200 uppercase tracking-wider mb-2">
              No commitment. No sales pitch.
            </p>
            <h3 className="font-heading font-bold text-lg md:text-2xl text-background-50 mb-2">
              Have a technology challenge or a hard-to-fill role?
            </h3>
            <p className="text-sm md:text-base text-background-200">
              Our senior team reads every inquiry. You&rsquo;ll hear from an expert — not a BDR.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            <button
              onClick={() => handleNavClick("#contact")}
              className="px-6 py-3 text-sm font-semibold rounded-md bg-background-50 text-primary-700 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Talk to an Expert
            </button>
            <button
              onClick={() => handleNavClick("#case-studies")}
              className="px-6 py-3 text-sm font-semibold rounded-md border border-background-300/40 text-background-50 hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              See Client Results
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}